(() => {
  const FEATURED = [1, 12, 24, 48, 100];

  const parseBreaks = (raw) =>
    String(raw || '')
      .split(',')
      .map((part) => {
        const [qty, off] = part.split(':').map((v) => Number(String(v).trim()));
        if (!qty || qty < 1 || Number.isNaN(off)) return null;
        return { qty, off: Math.max(0, Math.min(90, off)) };
      })
      .filter(Boolean)
      .sort((a, b) => a.qty - b.qty);

  const formatMoney = (cents, format) => {
    const value = (Math.max(0, cents) / 100).toFixed(2);
    return (format || '${{amount}} USD').replace(/\{\{amount[^}]*\}\}/g, value);
  };

  const offFor = (qty, breaks) => {
    let off = 0;
    for (const row of breaks) {
      if (qty >= row.qty) off = row.off;
    }
    return off;
  };

  const unitCents = (qty, baseCents, breaks) =>
    Math.round(baseCents * (1 - offFor(qty, breaks) / 100));

  const tableRows = (qty) => {
    const set = new Set(FEATURED);
    set.add(qty);
    return [...set].sort((a, b) => a - b);
  };

  const cell = (tag, text, className) => {
    const el = document.createElement(tag);
    el.textContent = text;
    if (className) el.className = className;
    return el;
  };

  const parseQty = (raw) => Math.max(1, Math.floor(Number(String(raw).replace(/\D+/g, '')) || 1));

  const selectQty = (input) => {
    input.dataset.rexvenReplace = '1';
    try {
      input.select();
    } catch (_) {
      /* ignore */
    }
  };

  const replaceQty = (input, incoming) => {
    if (input.dataset.rexvenReplace !== '1') return false;
    const digit = String(incoming || '').replace(/\D+/g, '');
    if (!digit) return false;
    delete input.dataset.rexvenReplace;
    input.value = digit;
    try {
      input.setSelectionRange(digit.length, digit.length);
    } catch (_) {
      /* ignore */
    }
    const root = rootOf(input);
    if (root) render(root, { commitQty: false });
    return true;
  };

  const render = (root, { syncQty = false, commitQty = true } = {}) => {
    const input = root.querySelector('.rexven-pricing__qty');
    const asLow = root.querySelector('.rexven-pricing__as-low');
    const body = root.querySelector('tbody');
    if (!input || !body) return;

    const qty = parseQty(input.value);
    if (commitQty) input.value = String(qty);

    const base = Number(root.dataset.price) || 0;
    const breaks = parseBreaks(root.dataset.breaks);
    const format = root.dataset.moneyFormat || '${{amount}} USD';
    const bestQty = FEATURED[FEATURED.length - 1];
    if (asLow && breaks.length) {
      asLow.hidden = false;
      asLow.textContent = `As low as ${formatMoney(unitCents(bestQty, base, breaks), format)} each at ${bestQty}+ pieces`;
    }

    body.replaceChildren(
      ...tableRows(qty).map((rowQty) => {
        const off = offFor(rowQty, breaks);
        const each = unitCents(rowQty, base, breaks);
        const tr = document.createElement('tr');
        if (rowQty === qty) tr.classList.add('is-current');
        const th = cell('th', String(rowQty));
        th.scope = 'row';
        tr.append(
          th,
          cell('td', formatMoney(each, format)),
          cell('td', formatMoney(each * rowQty, format)),
          cell('td', off ? `${off}%` : '—')
        );
        return tr;
      })
    );

    if (syncQty) {
      document.querySelectorAll('input.quantity__input[name="quantity"]').forEach((formQty) => {
        formQty.value = String(qty);
        formQty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };

  const rootOf = (el) => el?.closest?.('[data-rexven-pricing]');

  document.addEventListener('click', (event) => {
    const input = event.target.closest?.('.rexven-pricing__qty');
    if (input) {
      selectQty(input);
      return;
    }
    const button = event.target.closest?.('.rexven-pricing__submit');
    if (!button) return;
    const root = rootOf(button);
    if (root) render(root, { syncQty: true });
  });

  document.addEventListener('focusin', (event) => {
    const input = event.target.closest?.('.rexven-pricing__qty');
    if (input) selectQty(input);
  });

  document.addEventListener('mouseup', (event) => {
    const input = event.target.closest?.('.rexven-pricing__qty');
    if (!input) return;
    event.preventDefault();
    selectQty(input);
  });

  document.addEventListener('beforeinput', (event) => {
    const input = event.target.closest?.('.rexven-pricing__qty');
    if (!input) return;
    if (!replaceQty(input, event.data)) return;
    event.preventDefault();
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('.rexven-pricing__qty');
    if (!input) return;
    const cleaned = String(input.value).replace(/\D+/g, '');
    if (input.value !== cleaned) input.value = cleaned;
    const root = rootOf(input);
    if (root) render(root, { commitQty: false });
  });

  document.addEventListener(
    'blur',
    (event) => {
      const input = event.target.closest?.('.rexven-pricing__qty');
      if (!input) return;
      delete input.dataset.rexvenReplace;
      const root = rootOf(input);
      if (root) render(root);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest?.('.rexven-pricing__qty');
    if (!input) return;
    if (/^[0-9]$/.test(event.key) && input.dataset.rexvenReplace === '1') {
      event.preventDefault();
      replaceQty(input, event.key);
      return;
    }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Home' || event.key === 'End') {
      delete input.dataset.rexvenReplace;
    }
    if (event.key !== 'Enter') return;
    event.preventDefault();
    const root = rootOf(input);
    if (root) render(root, { syncQty: true });
  });

  document.addEventListener('change', (event) => {
    const formQty = event.target.closest?.('input.quantity__input[name="quantity"]');
    if (!formQty) return;
    const qty = Math.max(1, Math.floor(Number(formQty.value) || 1));
    document.querySelectorAll('[data-rexven-pricing]').forEach((root) => {
      const input = root.querySelector('.rexven-pricing__qty');
      if (input) input.value = String(qty);
      render(root);
    });
  });

  const boot = () => {
    document.querySelectorAll('[data-rexven-pricing]').forEach((root) => render(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // PUB_SUB_EVENTS is a top-level const in Dawn's constants.js, so it is not a window property.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const price = event?.data?.variant?.price;
      if (price == null) return;
      document.querySelectorAll('[data-rexven-pricing]').forEach((root) => {
        root.dataset.price = String(price);
        render(root);
      });
    });
  }
})();
